import { useEffect } from 'react';
import EnquiryActions from './EnquiryActions';
import { contactLinks, fmt, nightsBetween } from './enquiryUtils';

export default function EnquiryModal({ booking, onClose, run }) {
  useEffect(() => {
    const onKey = (event) => event.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const b = booking;
  const links = contactLinks(b);
  const nights = nightsBetween(b.check_in, b.check_out);
  const rows = [
    ['Check-in', fmt(b.check_in)],
    ['Check-out', fmt(b.check_out)],
    ['Length of stay', `${nights} night${nights > 1 ? 's' : ''}`],
    ['Guests', b.guests],
    ['Room', b.room_name || 'Not specified'],
    ['Email', b.email || '—'],
    ['Phone', b.phone || '—'],
    ['WhatsApp', links.whatsappNumber || '—'],
    ['Received', fmt(b.created_at)]
  ];

  return (
    <div className="enq-overlay" role="presentation" onClick={onClose}>
      <div className="enq-modal" role="dialog" aria-modal="true" aria-label={`Enquiry from ${b.name}`} onClick={(event) => event.stopPropagation()}>
        <header className="enq-modal-head">
          <div>
            <span className="eyebrow">Booking enquiry</span>
            <h2>{b.name}</h2>
          </div>
          <span className={`badge badge-${b.status}`}>{b.status}</span>
          <button type="button" className="enq-close" aria-label="Close" onClick={onClose}>×</button>
        </header>
        <dl className="enq-details">
          {rows.map(([label, value]) => (
            <div key={label}><dt>{label}</dt><dd>{value}</dd></div>
          ))}
        </dl>
        <div className="enq-message">
          <small>Special request</small>
          <p>{links.note || 'No special request.'}</p>
        </div>
        <EnquiryActions booking={b} links={links} run={async (action) => { await run(action); onClose(); }} compact />
      </div>
    </div>
  );
}